// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7y-4";
export var collapsed = "_7y-1";
export var headerBar = "_7y-0";
export var leftHeaderContent = "_7y-3";
export var subjectContainer = "_7y-2";